/* eslint-disable prettier/prettier */
import { FC } from "react";

interface CardProps {
    name: string;
    vendor: string;
    year: string | number;
    active?: boolean;
    onToggle?: () => void;
}

const styles = {
    container: "shadow-lg shadow-gray/70 m-4 text-gray-950 rounded-lg bg-gray-400 p-4 bg-gray-400 @max-[275px] w-[350px]",
    name: "pb-5 font-bold pt-2 text-lg text-CostcoAction-pressed",
    vendor: "pt-2 space-x-2 text-md",
    year: "pb-2 space-x-2 ",
};

const IndexCard: FC<CardProps> = ({ name, vendor, year }) => {
    return (
        <div className={styles.container}>
            <div className={`${styles.name}`}>
                {name}
            </div>
            <div className={styles.vendor}>
                <label className="font-semibold">Source</label>
                <label>{vendor}</label>
            </div>
            <div className={styles.year}>
                <label className="font-semibold">Year</label>
                <label>{year}</label>
            </div>
        </div>
    );
};

export default IndexCard;
